import { styled } from '@mui/material';

export const Styles = {
  SideMenu: styled('div')<{ isMobile: boolean }>(({ isMobile, theme }) => ({
    display: 'flex',
    flexDirection: isMobile ? 'row' : 'column',
    backgroundColor: '#989898',
    padding: '5px',
    boxSizing: 'border-box',
    width: isMobile ? '100%' : '210px',
    overflowX: isMobile ? 'auto' : 'visible',
    whiteSpace: isMobile ? 'nowrap' : 'normal',
    [theme.breakpoints.down('md')]: {
      position: 'sticky',
      top: 0,
      zIndex: 1000,
      boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
    }
  })),

  ActiveMenuItem: styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    fontSize: '13px',
    fontWeight: 'bold',
    height: '46px',
    backgroundColor: '#2FB674',
    color: 'white',
    padding: '0 10px',
    marginBottom: '3px',
    borderRadius: '0px',
    cursor: 'pointer'
  }),

  Section: styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(2),
    minWidth: '200px',
    marginRight: theme.spacing(1)
  })),

  MenuItem: styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    fontSize: '13px',
    fontWeight: 'bold',
    height: '46px',
    backgroundColor: '#FFFFFF',
    color: '#000000',
    padding: '0 10px',
    marginBottom: '3px',
    borderRadius: '0px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#2FB674',
      color: 'white'
    }
  }),
  SpecialMenuItem: styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    fontSize: '15px',
    fontWeight: 'bold',
    height: '46px',
    backgroundColor: '#000000',
    color: '#FFFFFF',
    padding: '0 10px',
    marginBottom: '3px',
    borderRadius: '0px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#2FB674',
      color: 'white'
    }
  }),
  Icon: styled('img')({
    width: '20px',
    height: '20px',
    marginRight: '10px',
    marginBottom: '5px'
  })
};
